import styled from "styled-components";
import { Button, Table,Form } from "semantic-ui-react";

export const Container = styled.div`
  background: #ffffff;
  padding-left:250px;
`;

export const Content = styled.div`
  width: 100%;
  padding: 2rem 1rem 3rem 1rem ;
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Redirect = styled.a`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const TableButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }
`;
export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  &:hover {
    cursor: pointer;
  }
`;

export const Field = styled(Form.Field)`
  margin: 20px 0 !important;
  width: ${(props) => (props.big && "80%") || (props.small && "20%")};
`;
export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  font-size: 12px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;
export const ButtonModalSubmit = styled.button`
  padding: 1rem 2rem;
  font-size: 1rem;
  color: #FFF;
  background: var(--color-primary);
  border:none;
  border-radius: 8px;
  &:hover{
    cursor: pointer;
    background: var(--color-primary-dark);
  }

`;